import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import './style/normalize.css'

import VueI18n from 'vue-i18n'


import FastClick from 'fastclick'
FastClick.attach(document.body)




import './modules/js/flexible.js'



Vue.use(VueI18n)

const VueUploadComponent = require('vue-upload-component')
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'

Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)
Vue.use(WechatPlugin)
Vue.use(AlertPlugin)
Vue.use(LoadingPlugin)
Vue.component('file-upload', VueUploadComponent)


const i18n = new VueI18n({
locale: 'zh-cn'
})


Vue.mixin({
methods: {
holdEmoji(value) {
if (typeof value !== 'string') {
return value
}
const reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F\uDE80-\uDEFF]/g
return value.replace(reg, '')
}
},
computed: {
isWx() {
let ua = window.navigator.userAgent
return ua.toLowerCase().indexOf('micromessenger') !== -1
}
}
})

/* eslint-disable no-new */
top.vm = new Vue({
el: '#app',
router,
i18n,
store,
template: '<App/>',
components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js